// Lomo lens: vignette + subtle edge blur, like an analogue camera lens.
// One full-screen pass after planet curvature, before CRT/VHS.

import * as THREE from 'three';

export const LomoLensShader = {
  uniforms: {
    tDiffuse: { value: null as THREE.Texture | null },
    resolution: { value: new THREE.Vector2(1, 1) },
    strength: { value: 0.6 },
  },

  vertexShader: /* glsl */ `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,

  fragmentShader: /* glsl */ `
    uniform sampler2D tDiffuse;
    uniform vec2 resolution;
    uniform float strength;
    varying vec2 vUv;

    void main() {
      vec2 cc = vUv - 0.5;
      float r2 = dot(cc, cc);
      float edge = smoothstep(0.08, 0.5, r2);

      // Edge blur: 4-tap cross blur, radius grows toward the edges.
      float blurRadius = edge * strength * 2.5;
      vec2 px = 1.0 / resolution;
      vec3 col = texture2D(tDiffuse, vUv).rgb;
      col += texture2D(tDiffuse, vUv + vec2(px.x * blurRadius, 0.0)).rgb;
      col += texture2D(tDiffuse, vUv - vec2(px.x * blurRadius, 0.0)).rgb;
      col += texture2D(tDiffuse, vUv + vec2(0.0, px.y * blurRadius)).rgb;
      col += texture2D(tDiffuse, vUv - vec2(0.0, px.y * blurRadius)).rgb;
      col /= 5.0;

      // Vignette: darken edges.
      float vignette = 1.0 - edge * strength * 0.5;
      col *= vignette;

      // Slight warm tint at the edges for the analogue feel.
      col = mix(col, col * vec3(1.05, 0.95, 0.85), edge * strength * 0.3);

      // Faint scanlines (always on, subtle).
      float scanline = sin(vUv.y * resolution.y * 3.14159) * 0.5 + 0.5;
      col *= 1.0 - scanline * 0.12 * strength;

      gl_FragColor = vec4(col, 1.0);
    }
  `,
};
